export default {
  state: {
    title: 'État',
    visible: 'Commande à table visible',
    on: 'Commande à table',
  },
  notes: {
    hidden: {
      title: 'La commande à table est masquée',
      description:
        "Elle est activée, mais votre boutique ne l'affiche pas : toutes les commandes à table sont donc refusées. Activez « Commande à table visible » pour l'afficher.",
      link: 'Accéder au commutateur',
    },
    off: {
      title: 'Les clients ne peuvent pas commander à table pour l’instant',
      description:
        'Activez les deux interrupteurs pour démarrer. D’ici là, le QR code d’une table ouvre votre boutique avec Retrait et Livraison.',
    },
    no_active_table: {
      title: 'Les clients ne peuvent pas encore commander à table',
      description: 'Ajoutez une table ci-dessous et activez-la.',
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
};
